import CommonButton from "../ui/CommonButton/CommonButton";
import classes from "./CommonFooter.module.css";

const CommonFooter = ({
  handlePrevious,
  handleNext,
  handleDone,
  handleCancel,
  currentSet,
  questionSets,
  doneText = "Done",
  nextText = "Next question set",
  cancelText,
  disabled,
  hideDone,
}) => {
  return (
    <div
      className={`${classes.footerContainer} position-fixed end-0 bg-white border-top d-flex justify-content-between gap-3`}
    >
      <div>
        {currentSet > 0 && (
          <CommonButton
            title="Previous"
            className={classes.previousButton}
            onClick={handlePrevious}
            disabled={disabled}
          />
        )}
      </div>
      {!hideDone && (
        <div>
          {currentSet < questionSets.length - 1 ? (
            <div className="d-flex align-items-center gap-2">
              {cancelText && (
                <CommonButton
                  title={cancelText}
                  className={classes.previousButton}
                  onClick={handleCancel}
                  disabled={disabled}
                />
              )}
              <CommonButton
                title={nextText}
                className={classes.nextButton}
                onClick={handleNext}
                disabled={disabled}
              />
            </div>
          ) : (
            <div className="d-flex align-items-center gap-2">
              {cancelText && (
                <CommonButton
                  title={cancelText}
                  className={classes.previousButton}
                  onClick={handleCancel}
                  disabled={disabled}
                />
              )}
              <CommonButton
                title={doneText}
                className={classes.nextButton}
                onClick={handleDone}
                disabled={disabled}
              />
            </div>
          )}
        </div>
      )}
    </div>
  );
};
export default CommonFooter;
